module.exports = __webpack_public_path__ + "static/media/Illus-Berry.58b8f5e7.png";